export default __webpack_public_path__ + "img/cctv-camera.b0f43c8a.png";